<template>
  <router-link
    :to="{ name: Pages.quickStartGuide }"
  >
    <div class="icon-wrapper">
      <TbBookOpenIcon
        class="book-icon"
      />
      <p class="link-info">
        Quick Start Guide
      </p>
    </div>
  </router-link>
</template>

<script setup lang="ts">
import { Pages } from '@/router';
import { TbBookOpenIcon } from '@/components/tasty_bistro';

</script>

<style lang="scss" scoped>
.icon-wrapper {
  @apply
    fixed
    bottom-0
    right-[118px]
    z-40
    my-3.5
    mx-5
    w-[46px]
    h-[46px]
    flex
    justify-center
    items-center
    bg-[#424A68]
    rounded-full
    duration-100;

    &:hover {
      @apply bg-gray-700 cursor-pointer;

      .link-info {
        @apply inline-flex
      }
    }
}

.book-icon {
  @apply
    w-5
    h-5
    text-white
}

.link-info {
  @apply
    absolute
    -left-8
    -top-7
    text-gray-800
    font-medium
    whitespace-nowrap
    hidden
}
</style>
